/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState, useMemo } from "react";
import DOMPurify from "dompurify";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { Images } from "./Images";
import CustomDatePicker from "./CustomDatePicker";
import CustomSearchableDropdown from "./CustomSearchableDropdown";
import CustomSearchableDropdownTickmark from "./CustomSearchableDropdownTickmark";
import StepProgress from "./StepProgress";
import NotificationMessage from "./NotificationMessage";
import NoVehiclePopUp from "./NoVehiclePopUp.jsx";
import { getFirstname, getLastname, getEmailID } from "../../utils/SecurityService.js";
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler.js";

import { formatDate, formatDateToLong, isPastTimeInterval, toSafeFloat } from "../../utils/CommonUtils";
import { MapBasedBooking_api, SpotAvailability_api } from "../NewBooking/NewBookingAPI";
import { BookingStatus_api, MapBasedBooking_apiBookingStatus, PostBookingQuestion_api } from "../WeeklyCalendar/WeeklyCalendarAPI.jsx";
import PostbookingQueModal from "./PostbookingQueModal.jsx";
import loadingGIF from "../../assets/images/loading.gif"
const BookParkingOrDesk = ({ selectedTab, step, setStep, bookingInfo, setZoneCreditValue }) => {
    const { t } = useTranslation()
    const history = useHistory();
    const FirstName = getFirstname();
    const LastName = getLastname();
    const memberEmail = getEmailID();
    const [notification, setNotification] = useState(null);
    const [errors, setErrors] = useState({});
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedFrom, setSelectedFrom] = useState("09:00");
    const [selectedTo, setSelectedTo] = useState("09:30");
    const [maxDate, setMaxDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedType, setSelectedType] = useState(null);

    //const [zoneCreditValue, setZoneCreditValue] = useState();
    const [individualDayCost, setIndividualDayCost] = useState("0");

    const vehicleRef = useRef(null);
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const [showSlots, setShowSlots] = useState(false);
    const [activeField, setActiveField] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const isTimeNotSelected = selectedType === 2 && (selectedFrom === "00:00" || selectedTo === "00:00" || selectedFrom === "" || selectedTo === "");

    const isTimeMissing = selectedType === 2 && (selectedFrom === "00:00" || selectedTo === "00:00" || selectedFrom === "" || selectedTo === "");
    const [showStep2Slots, setShowStep2Slots] = useState(false);
    const [timeSelectedInStep1, setTimeSelectedInStep1] = useState(false);
    const [showStep1TimeValidation, setShowStep1TimeValidation] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    const [selectedSpace, setSelectedSpace] = useState("");
    const [spacesList, setSpacesList] = useState([]);
    const [cachedStep2Spaces, setCachedStep2Spaces] = useState([]);
    const [skipStep2RefetchOnce, setSkipStep2RefetchOnce] = useState(false);
    const [zoneCurrentDate, setZoneCurrentDate] = useState("");
    const [zoneCurrentTime, setZoneCurrentTime] = useState("");

    const [isFullyDayBlocked, setIsFullyDayBlocked] = useState(0);
    const [isRoomHasApprover, setIsRoomHasApprover] = useState(0);
    const isDisableOnSpotApi = isFullyDayBlocked === 1 || (isRoomHasApprover === 1 && isFullyDayBlocked === 1);

    //handle Postbooking Que Modal
    const [showPostbookingQueModal, setShowPostbookingQueModal] = useState(false);
    const [postbookingQueModalData, setPostbookingQueModalData] = useState([]);
    const [postRequestParams, setPostRequestParams] = useState(null);
    const [showNoVehiclePopup, setShowNoVehiclePopup] = useState(false);

    const {
        handleResponseCode,
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    } = useApiResponseHandler();
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);
    const selectedZoneObj = useMemo(() => {

        return bookingInfo?.ZoneList?.find(
            z => String(z.Id) === String(selectedZone)
        );

    }, [selectedZone, bookingInfo]);

    const displaySpacesList =
        step === 1 && spacesList.length === 0 && cachedStep2Spaces.length > 0
            ? cachedStep2Spaces
            : spacesList;

    const zoneCreditValue = Number(selectedZoneObj?.ZoneCreditValue ?? 0);
    const displaySelectedDate =
        selectedDate instanceof Date && !isNaN(selectedDate.getTime())
            ? `${String(selectedDate.getDate()).padStart(2, "0")} ${t(
                selectedDate.toLocaleString("en-GB", { month: "long" })
            )} ${selectedDate.getFullYear()}`
            : "";

    useEffect(() => {
        if (!selectedZone && bookingInfo?.ZoneList?.length > 0) {
            setSelectedZone(bookingInfo.ZoneList[0].Id);
        }
    }, [bookingInfo, selectedZone]);

    useEffect(() => {
        if (setZoneCreditValue) {
            setZoneCreditValue(zoneCreditValue);
        }
    }, [zoneCreditValue]);

    const typeList = useMemo(() => {

        if (!selectedZoneObj) return [];

        const list = [];

        if (selectedZoneObj.IsDailySpotExist) {
            list.push({ TypeId: 1, TypeName: t("all_day") });
        }
        if (selectedZoneObj.IsHourlySpotExist) {
            list.push({ TypeId: 2, TypeName: t("hourly") });
        }
        return list;

    }, [selectedZoneObj, t]);

    useEffect(() => {
        if (typeList.length > 0) {
            setSelectedType(typeList[0].TypeId);
        }
    }, [typeList]);

    // #region Vehicle- start
    const vehicleList = useMemo(() => {

        if (!selectedZoneObj) return [];

        const enabled = (selectedZoneObj.EmployeeEnabledVehicle || []).map(v => ({
            ...v,
            isDisabledVehicle: false
        }));
        const disabled = (selectedZoneObj.EmployeeDisabledVehicle || []).map(v => ({
            ...v,
            isDisabledVehicle: true
        }));

        return [...enabled, ...disabled];

    }, [selectedZoneObj]);

    // selected vehicle object
    const selectedVehicleObj = useMemo(() => {
        return vehicleList.find(v => v.VehiclePrimaryKey === selectedVehicle);
    }, [selectedVehicle, vehicleList]);

    const shouldDisableNextButton =
        selectedTab === 1 &&
        step === 0 &&
        !!selectedZoneObj &&
        vehicleList.length === 0;

    useEffect(() => {
        if (selectedTab !== 1 || step !== 0 || !selectedZoneObj) {
            setShowNoVehiclePopup(false);
            return;
        }

        if (vehicleList.length === 0) {
            setShowNoVehiclePopup(true);
            return;
        }

        setShowNoVehiclePopup(false);
    }, [selectedTab, step, selectedZoneObj, vehicleList]);

    // default vehicle
    useEffect(() => {
        if (!selectedVehicle && vehicleList.length > 0 && selectedTab === 1) {
            setSelectedVehicle(vehicleList[0].VehiclePrimaryKey);
        }
    }, [vehicleList]);

    // validate selected vehicle (runs on initial auto-select AND on change)
    useEffect(() => {
        if (selectedTab !== 1) return;
        setErrors((prev) => ({
            ...prev,
            vehicle: selectedVehicleObj?.isDisabledVehicle
                ? t("react_none_of_your_vehicles_can_be_parked_in_this_zone")
                : "",
        }));
    }, [selectedVehicleObj, selectedTab, t]);

    // #endregion Vehicle- end

    // #region Extracted tags for the selected zone- start
    const spotTagList = useMemo(() => {

        if (!selectedZoneObj) return [];

        return selectedZoneObj.Tags || [];

    }, [selectedZoneObj]);

    const toggleTag = (tagId) => {

        setSelectedTags((prev) => {

            if (prev.includes(tagId)) {
                return prev.filter(id => id !== tagId); // unselect
            }
            return [...prev, tagId]; // select
        });

    };
    // #endregion Extracted tags for the selected zone- end

    const firstLoad = useRef(true);

    useEffect(() => {

        if (firstLoad.current) {
            firstLoad.current = false;
            return;
        }
        setSelectedFrom("00:00");
        setSelectedTo("00:00");
        setShowSlots(false);
        setActiveField(null);
        setSelectedTags([]);
        setShowStep1TimeValidation(false);

    }, [selectedZone]);

    useEffect(() => {

        if (!selectedZoneObj || selectedType !== 2) {
            setTimeSlots([]);
            return;
        }
        if (step === 1) {
            const sourceSpaces = spacesList.length > 0 ? spacesList : cachedStep2Spaces;
            const selectedStep2Space = sourceSpaces.find((item) => item.Id === selectedSpace);
            const step2Intervals = (selectedStep2Space?.TimeInterval || []).map((slot) => {
                const [from = "", to = ""] = String(slot).split("-");
                return `${from.trim()}-${to.trim()}`;
            });
            setTimeSlots(step2Intervals);
            return;
        }

        const intervals = selectedZoneObj.TimeInterval || [];
        const slots = [];

        for (let i = 0; i < intervals.length - 1; i++) {
            slots.push(`${intervals[i]}-${intervals[i + 1]}`);
        }
        setTimeSlots(slots);

    }, [selectedType, selectedZoneObj, step, spacesList, cachedStep2Spaces, selectedSpace]);

    const timePoints = useMemo(() => {

        if (!selectedZoneObj || selectedType !== 2) return [];

        return selectedZoneObj.TimeInterval || [];

    }, [selectedType, selectedZoneObj]);

    // #region Interval-Time slot click handler- start
    const handleSlotClick = (slot) => {

        const [from, to] = slot.split("-");
        setSelectedFrom(from);
        setSelectedTo(to);
        // ✅ Detect where selection happened
        if (step === 0) {
            setTimeSelectedInStep1(true);
        }
        //setShowStep2Slots(true); // keep visible
    };

    const normalizeStep2Slot = (slot) => String(slot || "").replace(/\s/g, "");

    const isStep2SlotDisabled = (slot) => {
        if (step !== 1 || selectedType !== 2) return false;

        const normalizedSlot = normalizeStep2Slot(slot);
        const bookedSlots = (selectedSpaceObj?.BookedSlots || []).map(normalizeStep2Slot);
        const blockedSlots = (selectedSpaceObj?.BlockedBookingTime || []).map(normalizeStep2Slot);
        const isPastSlot = isPastTimeInterval(
            slot,
            zoneCurrentTime,
            selectedDate,
            zoneCurrentDate
        );

        return bookedSlots.includes(normalizedSlot) || blockedSlots.includes(normalizedSlot) || isPastSlot;
    };

    const getSelectedSlotIndexes = () => {
        return timeSlots.reduce((indexes, currentSlot, index) => {
            const [slotStart, slotEnd] = currentSlot.split("-");

            if (
                selectedFrom &&
                selectedTo &&
                selectedFrom !== "00:00" &&
                selectedTo !== "00:00" &&
                slotOverlapsRange(slotStart, slotEnd, selectedFrom, selectedTo)
            ) {
                indexes.push(index);
            }

            return indexes;
        }, []);
    };

    const getReachableStep2Index = (fromIndex, toIndex) => {
        const direction = toIndex > fromIndex ? 1 : -1;
        let reachableIndex = fromIndex;

        for (
            let index = fromIndex + direction;
            direction > 0 ? index <= toIndex : index >= toIndex;
            index += direction
        ) {
            if (isStep2SlotDisabled(timeSlots[index])) {
                break;
            }

            reachableIndex = index;
        }

        return reachableIndex;
    };

    const handleConsecutiveSlotClick = (slot) => {

        const clickedIndex = timeSlots.indexOf(slot);

        if (clickedIndex === -1 || isStep2SlotDisabled(slot)) return;

        const selectedIndexes = getSelectedSlotIndexes();

        if (selectedIndexes.length === 0) {
            handleSlotClick(slot);
            return;
        }

        const firstIndex = selectedIndexes[0];
        const lastIndex = selectedIndexes[selectedIndexes.length - 1];

        if (clickedIndex === firstIndex && clickedIndex === lastIndex) {
            setSelectedFrom("00:00");
            setSelectedTo("00:00");
        } else if (clickedIndex === firstIndex) {
            const [from, to] = timeSlots[firstIndex].split("-");
            setSelectedFrom(from);
            setSelectedTo(to);
        } else if (clickedIndex === lastIndex) {
            const [, to] = timeSlots[lastIndex - 1].split("-");
            setSelectedTo(to);
        } else if (clickedIndex < firstIndex) {
            const reachableIndex = getReachableStep2Index(firstIndex, clickedIndex);
            const [from] = timeSlots[reachableIndex].split("-");
            setSelectedFrom(from);
        } else if (clickedIndex > lastIndex) {
            const reachableIndex = getReachableStep2Index(lastIndex, clickedIndex);
            const [, to] = timeSlots[reachableIndex].split("-");
            setSelectedTo(to);
        } else {
            // In step 2, clicking a selected slot inside the range should keep
            // the earlier consecutive slots selected, including the clicked
            // slot, and unselect anything after it.
            const [, to] = timeSlots[clickedIndex].split("-");
            setSelectedTo(to);
        }

        if (step === 0) {
            setTimeSelectedInStep1(true);
        }
    };

    const handleTimePointClick = (time) => {
        if (activeField === "from") {
            setSelectedFrom(time);
            setShowSlots(false);
        } else if (activeField === "to") {
            setSelectedTo(time);
            setShowSlots(false);
        }

        if (step === 0) {
            setTimeSelectedInStep1(true);
        }
    };

    useEffect(() => {
        // Reset when user changes zone/date
        setTimeSelectedInStep1(false);
        setShowSlots(false);
        setActiveField(null);
        setShowStep1TimeValidation(false);
    }, [selectedZone, selectedDate]);

    const toMinutes = (time) => {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + m;
    };

    const isStartTimeMissing =
        selectedType === 2 &&
        (!selectedFrom || selectedFrom === "00:00") &&
        selectedTo &&
        selectedTo !== "00:00";

    const isEndTimeMissing =
        selectedType === 2 &&
        selectedFrom &&
        selectedFrom !== "00:00" &&
        (!selectedTo || selectedTo === "00:00");

    const isInvalidTimeRange =
        selectedType === 2 &&
        selectedFrom &&
        selectedTo &&
        selectedFrom !== "00:00" &&
        selectedTo !== "00:00" &&
        toMinutes(selectedTo) <= toMinutes(selectedFrom);

    const timeValidationMessage = isStartTimeMissing
        ? t("please_select_start_time")
        : isEndTimeMissing
            ? t("please_select_end_time")
            : isInvalidTimeRange
                ? t("react_end_time_must_be_after_start_time")
                : "";

    useEffect(() => {
        if (!timeValidationMessage) {
            setShowStep1TimeValidation(false);
        }
    }, [timeValidationMessage]);

    const handleStep1Next = () => {
        if (selectedTab === 1 && step === 0 && !!selectedZoneObj && vehicleList.length === 0) {
            setShowNoVehiclePopup(true);
            return;
        }

        if (timeValidationMessage) {
            setShowStep1TimeValidation(true);
            return;
        }

        setSelectedSpace("");
        setSpacesList([]);
        setCachedStep2Spaces([]);
        setSpotsLoading(true);
        setShowStep1TimeValidation(false);
        setStep(1);
    };

    const handleStep2Back = () => {
        if (!timeSelectedInStep1) {
            setSelectedFrom("00:00");
            setSelectedTo("00:00");
        }

        setStep(0);
    };

    const handleStep3Back = () => {
        setCheckedPreBookingQue(false);
        setSelectedFrom("00:00");
        setSelectedTo("00:00");
        setSkipStep2RefetchOnce(true);
        setStep(1);
    };

    const slotOverlapsRange = (slotStart, slotEnd, rangeStart, rangeEnd) => {

        const slotStartMin = toMinutes(slotStart);
        const slotEndMin = toMinutes(slotEnd);
        const rangeStartMin = toMinutes(rangeStart);
        const rangeEndMin = toMinutes(rangeEnd);
        return slotStartMin >= rangeStartMin && slotEndMin <= rangeEndMin;
    };

    useEffect(() => {
        if (step === 1 && isTimeNotSelected) {
            setShowStep2Slots(true);
        }
    }, [step]);

    // #endregion Interval-Time slot click handler- end

    // #region Fetch available spots when step 2 is active- start
    const [spotsLoading, setSpotsLoading] = useState(false);
    const isStep2NoSpaceAvailable =
        step === 1 &&
        !spotsLoading &&
        spacesList.length === 0 &&
        cachedStep2Spaces.length === 0;

    const fetchSpots = async () => {

        if (!selectedZone) return;

        try {

            setSpotsLoading(true);

            const params = {
                BookingDate: formatDate(selectedDate),
                ZoneId: selectedZone,
                SelectedTab: selectedTab,   // 1 for parking, 2 for desking

                FilterByStartTime: selectedFrom === "00:00" ? "" : selectedFrom,
                FilterByEndTime: selectedTo === "00:00" ? "" : selectedTo,

                FilterByTags: selectedTags.join(","),

                FilterByBookingPeriod: selectedType,

                VehicleSizeId: selectedVehicleObj?.SizeId || 0,
                AccessibleId: selectedVehicleObj?.AccessibleId || 0,
                ShareableId: selectedVehicleObj?.ShareableId || 0,
                FuelId: selectedVehicleObj?.FuelId || 0,
            };

            const response = await SpotAvailability_api(params);
            if (setZoneCreditValue) {
                setZoneCreditValue(response?.Data?.Records?.ZoneCreditValue);
            }
            setIndividualDayCost(response?.Data?.Records?.IndividualDayCost);

            /* handleApiResponse(response, setNotification, t, {
                successMsg: 0,
                errorMsg: 1
            }); */
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });
            if (response?.Data?.ResponseCode !== 200) {
                setStep(0);
                return;
            }
            const records = response?.Data?.Records || {};
            setZoneCurrentDate(records.ZoneCurrentDate || "");
            setZoneCurrentTime(records.ZoneCurrentTime || "");

            const dailySpots = records.AvailableDailyBookings || [];
            const hourlySpots = records.AvailableHourlyBookings || [];

            if (selectedType === 1 && dailySpots.length === 0) {
                setIsFullyDayBlocked(response?.Data?.Records?.AvailableDailyBookings?.IsFullyDayBlocked || 0);
                setIsRoomHasApprover(response?.Data?.Records?.AvailableDailyBookings?.IsRoomHasApprover || 0);
            }
            else if (selectedType === 2 && hourlySpots.length === 0) {
                setIsFullyDayBlocked(response?.Data?.Records?.AvailableHourlyBookings?.IsFullyDayBlocked || 0);
                setIsRoomHasApprover(response?.Data?.Records?.AvailableHourlyBookings?.IsRoomHasApprover || 0);
            }
            const spots =
                dailySpots.length > 0
                    ? dailySpots
                    : hourlySpots;

            setSpacesList(spots);
            if (spots.length > 0) {
                setCachedStep2Spaces(spots);
            }
            setPreBookingQuestion(records?.PreBookingQuestion ? records.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");

        } catch (error) {

            console.error("Spot API error", error);

        } finally {

            setSpotsLoading(false);
        }

    };

    useEffect(() => {

        if (step !== 1) return;

        if (skipStep2RefetchOnce) {
            setSkipStep2RefetchOnce(false);
            return;
        }

        fetchSpots();

    }, [step, skipStep2RefetchOnce]);

    useEffect(() => {
        if (displaySpacesList.length > 0) {
            const selectedSpotExists = displaySpacesList.some((item) => item.Id === selectedSpace);
            const firstSpot = selectedSpotExists
                ? displaySpacesList.find((item) => item.Id === selectedSpace)
                : displaySpacesList[0];

            if (!selectedSpotExists) {
                setSelectedSpace(firstSpot.Id);
            }
            setIsRoomHasApprover(firstSpot.IsRoomHasApprover || 0);
            setIsFullyDayBlocked(firstSpot.IsFullyDayBlocked || 0);
        }
    }, [displaySpacesList, selectedSpace]);

    const selectedSpaceObj = useMemo(() => {
        return displaySpacesList.find((item) => item.Id === selectedSpace);
    }, [displaySpacesList, selectedSpace]);


    // #endregion Fetch available spots when step 2 is active- end

    const [preBookingQuestion, setPreBookingQuestion] = useState("");
    const [checkedPreBookingQue, setCheckedPreBookingQue] = useState(false);
    const safeHtml = DOMPurify
        .sanitize(preBookingQuestion)
        .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

    /* const safeHtml = DOMPurify
        .sanitize(preBookingQuestion)
        .replace(/<a\b([^>]*)>/g, '<a class="w-auto" target="_blank" rel="noopener noreferrer" $1>')
        .replace(/<\/?p>/g, ""); */

    const isPreBookingQuestionChecked = Boolean(preBookingQuestion) && !checkedPreBookingQue;
    const isStep2NextDisabled =
        spotsLoading ||
        !selectedSpace ||
        isStep2NoSpaceAvailable ||
        isPreBookingQuestionChecked ||
        isTimeMissing ||
        isDisableOnSpotApi;

    const handleConfirmBooking = async () => {

        try {
            setIsLoading(true);
            const selectedSpaceName = selectedSpaceObj?.SpotName || "";
            const params = {
                BookingDate: formatDate(selectedDate),
                ZoneId: selectedZone,
                SpotId: selectedSpace,

                TeamMemberGuId: "",

                Tags: selectedTags.join(","),

                BookingPeriodStartTime: selectedFrom === "00:00" ? "" : selectedFrom,
                BookingPeriodEndTime: selectedTo === "00:00" ? "" : selectedTo,

                VehicleTypeId: selectedVehicleObj?.SizeId || 0,
                VehicleFuelId: selectedVehicleObj?.FuelId || 0,
                VehicleAccessibleId: selectedVehicleObj?.AccessibleId || 0,
                VehicleShareableId: selectedVehicleObj?.ShareableId || 0,

                // as no guest booking so below should be blank
                IsGuest: 0,
                NationalId: "",
                FirstName: "",
                LastName: "",
                EmailAddress: "",
                CarRegistrationNumber: selectedVehicleObj?.VehicleRegistrationId || "",
                // Wifi details- can be added later if needed
                /* SsId: "",
                BssId: "",
                WifiToggleStatus: 0, */
            };

            const response = await MapBasedBooking_api(params);
            /* handleApiResponse(response, setNotification, t, {
                successMsg: 0,
                errorMsg: 1
            }); */
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });
            if (response?.Data?.ResponseCode === 200) {
                const bookingStatusreqParams = {
                    ZoneId: selectedZone,
                    MapBookingQueueId: response?.Data?.Records?.MapBookingQueueId,
                    IsGuest: 0,    // ONLY for New Booking
                    BookingDate: formatDate(selectedDate),
                    // FROM SELECTED VEHICLE
                    VehicleTypeId: selectedVehicleObj?.SizeId || 0,
                    VehicleFuelId: selectedVehicleObj?.FuelId || 0,
                    VehicleAccessibleId: selectedVehicleObj?.AccessibleId || 0,
                    VehicleShareableId: selectedVehicleObj?.ShareableId || 0,
                };
                const statusResult = await pullBookingStatus(bookingStatusreqParams);
            }
            setIsLoading(false);

        } catch (error) {

            console.error("Booking API error", error);
            setIsLoading(false);
        }
        finally { setIsLoading(false); }
    };

    const pullBookingStatus = async (reqParams) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            try {

                const response = await MapBasedBooking_apiBookingStatus(reqParams);
                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => {
                            if (!reqParams.ZoneId || !selectedDate) return;
                            //await fetchBookings(selectedZoneId, formatDate(selectedDate));
                        }
                    }
                });
                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    // history.push("/Login", { replace: true });
                    return { stopFetch: true };
                }

                /* if (errorCode === 416 || errorCode === 427 || errorCode === 605) {
                    return { stopFetch: true };
                } */
                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }
                if (Number(spotId) === -1) {
                    return { stopFetch: false };
                }

                if (Number(spotId) > 0) {

                    /* handleApiResponse(response, setNotification, t, {
                        successMsg: 1,
                        errorMsg: 1
                    }); */
                    /* handleApiUiResponse(response, {
                        successToaster: 1,
                        errorToaster: 1,
                        alertPopup: 1
                    }); */
                    if (isPastBooking === 1) {

                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {

                            const questions = res?.Data?.Records?.QuestionAnswerList || [];

                            setPostRequestParams({
                                ZoneId: reqParams.ZoneId,
                                ClaimDate: formatDate(selectedDate),
                                StartTime: "",
                                EndTime: "",
                                SpotId: spotId,
                                ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                CompanyId: res?.Data?.Records?.CompanyId,
                                IsGuest: reqParams.IsGuest
                            });

                            setPostbookingQueModalData(questions);
                            setShowPostbookingQueModal(true);

                            return { stopFetch: true };
                        }
                    }
                    else { history.push("/booking"); }
                    return { stopFetch: false };
                }

                if (attempt < maxAttempts) {
                    await new Promise(res => setTimeout(res, 3000));
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    return (
        <div className="tab-content active">
            {isLoading && (
                <div id='preloader'>

                    <img src={loadingGIF} alt="" />
                </div>
            )}
            <StepProgress step={step} activeTab="parking" />
            {/* STEP 1 */}
            {step === 0 && (
                <div className="step active" data-step="0">
                    <form>

                        {/* Zone */}
                        <div className=" mb-4">
                            <label className="popup-inner-title mt-0">{t("zone")}</label>
                            <CustomSearchableDropdown
                                items={bookingInfo?.ZoneList || []}
                                value={selectedZone}
                                labelKey="ZoneName"
                                valueKey="Id"
                                placeholder={t("select_a_zone")}
                                searchable={false}
                                onChange={(val) => setSelectedZone(val)}
                                noOptionsMessage={t("no_zone_available")}
                            />
                        </div>

                        {/* Date */}
                        <div className="date-picker-wrapper  mb-4">
                            <label className="popup-inner-title mt-0">{t("date")}</label>
                            <CustomDatePicker
                                id="datepicker"
                                selected={selectedDate}
                                onChange={(d) => {
                                    const newDate = d ? d : new Date();
                                    // reset selected time
                                    setSelectedFrom("00:00");
                                    setSelectedTo("00:00");
                                    setSelectedDate(newDate);
                                }}
                                minDate={new Date()} // optional: disallow past dates
                                maxDate={maxDate}
                                onKeyDown={(e) => e.preventDefault()}
                                onChangeRaw={(e) => e.preventDefault()}
                            />
                        </div>

                        {/* Type */}
                        <div className=" mb-4">
                            <label className="popup-inner-title mt-0">{t("react_type_label")}</label>

                            <CustomSearchableDropdown
                                key={`type-${selectedZone}`}
                                items={typeList}
                                value={selectedType}
                                labelKey="TypeName"
                                valueKey="TypeId"
                                searchable={false}
                                onChange={(value) => setSelectedType(value)}
                            />


                        </div>

                        {/* Time */}
                        {selectedType === 2 && (
                            <div className="custom-timepicker ">
                                <label className="popup-inner-title">
                                    {t("react_select_time")}
                                </label>

                                <div
                                    className={`selected-box bg-white ${selectedFrom && selectedTo && !(selectedFrom === "00:00" && selectedTo === "00:00")
                                        ? "ctm-success"
                                        : ""
                                        }`} >
                                    <div
                                        onClick={() => {
                                            setActiveField("from");
                                            setShowSlots(true);
                                        }}
                                    >
                                        {t("from")} <span className={selectedFrom === "00:00" ? "text-grey" : ""}>{selectedFrom}</span>
                                    </div>

                                    <div className="text-center">
                                        <img src={Images.RightBlackArrow} className="img-fluid" />
                                    </div>

                                    <div
                                        onClick={() => {
                                            setActiveField("to");
                                            setShowSlots(true);
                                        }}
                                    >
                                        {t("react_to")} <span className={selectedTo === "00:00" ? "text-grey" : ""}>{selectedTo}</span>
                                    </div>
                                </div>
                                {showSlots && (
                                    <div className="slot-container d-grid mb-3">

                                        {timePoints.map((time, idx) => {

                                            const isDisabled = false;
                                            const hasFromValue = selectedFrom && selectedFrom !== "00:00";
                                            const hasToValue = selectedTo && selectedTo !== "00:00";
                                            const pointMinutes = toMinutes(time);
                                            const fromMinutes = hasFromValue ? toMinutes(selectedFrom) : null;
                                            const toMinutesValue = hasToValue ? toMinutes(selectedTo) : null;

                                            const isSelected =
                                                hasFromValue &&
                                                (
                                                    time === selectedFrom ||
                                                    (hasToValue && pointMinutes >= fromMinutes && pointMinutes <= toMinutesValue)
                                                );

                                            return (
                                                <div
                                                    key={idx}
                                                    className={`slot ${isDisabled ? "disabled" : ""} ${isSelected ? "active" : ""}`}
                                                    onClick={() => {
                                                        if (!isDisabled) handleTimePointClick(time);
                                                    }}
                                                >
                                                    {time}
                                                </div>
                                            );
                                        })}

                                    </div>
                                )}

                                {showStep1TimeValidation && timeValidationMessage && (
                                    <div className="error-text">
                                        <img src={Images.ErrorMsg} className="img-fluid" />
                                        <p>{timeValidationMessage}</p>
                                    </div>
                                )}


                            </div>
                        )}

                        {/* Vehicle */}
                        {(selectedTab === 1 && vehicleList.length > 0) && (
                            <div className="mb-4" ref={vehicleRef}>

                                <label className="popup-inner-title mt-0">{t("vehicle")}</label>

                                <CustomSearchableDropdown
                                    key={`vehicle-${selectedZone}`}
                                    items={vehicleList}
                                    value={selectedVehicle}
                                    labelKey="VehicleRegistrationId"
                                    valueKey="VehiclePrimaryKey"
                                    searchable={false}
                                    noOptionsMessage={t("there_is_no_car_plate")}
                                    onChange={(value) => {

                                        setSelectedVehicle(value);

                                        const vehicle = vehicleList.find(
                                            v => v.VehiclePrimaryKey === value
                                        );

                                        // error message is handled by the validation effect;
                                        // here we only scroll to it on the user's selection
                                        if (vehicle?.isDisabledVehicle) {
                                            vehicleRef.current?.scrollIntoView({
                                                behavior: "smooth",
                                                block: "center"
                                            });
                                        }

                                    }}

                                />

                                {errors.vehicle && (
                                    <div className="error-text">
                                        <img src={Images.ErrorMsg} className="img-fluid" />
                                        <p>{errors.vehicle}</p>
                                    </div>
                                )}

                            </div>
                        )}

                        {/* Tags */}
                        {spotTagList?.length > 0 && (
                            <div className="">
                                <label className="popup-inner-title mt-0">{t("tags")}</label>
                                <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                                    {spotTagList?.map((tag) => (

                                        <button
                                            key={tag.Id}
                                            type="button"
                                            className={selectedTags.includes(tag.Id) ? "selected" : ""}
                                            onClick={() => toggleTag(tag.Id)}
                                        >
                                            {tag.Name}
                                        </button>

                                    ))}

                                </div>
                            </div>
                        )}

                    </form>
                </div>
            )}

            {/* STEP 2 */}
            {step === 1 && (
                <div className="step active" data-step="1">

                    <form>
                        {/* Space */}
                        <div className=" mb-4">
                            <label className="popup-inner-title mt-0">{t("react_spots")} </label>
                            <CustomSearchableDropdownTickmark
                                items={displaySpacesList}
                                value={selectedSpace}
                                labelKey="SpotName"
                                valueKey="Id"
                                searchable={false}
                                disabled={displaySpacesList.length === 0}
                                placeholder={
                                    displaySpacesList.length === 0
                                        ? t("no_space_available")
                                        : t("react_select_space")
                                }
                                onChange={(value) => {
                                    setSelectedSpace(value);

                                    const selectedSpotObj = displaySpacesList.find(
                                        (item) => item.Id === value
                                    );

                                    if (selectedSpotObj) {
                                        setIsRoomHasApprover(selectedSpotObj.IsRoomHasApprover || 0);

                                        // ⚠️ Not available in your API per spot → keep 0
                                        setIsFullyDayBlocked(selectedSpotObj.IsFullyDayBlocked || 0);
                                    }
                                }}

                            />

                            {/* <img src={Images.RollIconGray} alt="" className="map-icon" /> */}
                        </div>
                        {isStep2NoSpaceAvailable && (
                            <div className="no-space-found text-center mt-3">

                                <img
                                    src={Images.NoSpaceError}
                                    className="img-fluid mb-2"
                                    style={{ maxWidth: "160px" }}
                                />

                                <p className="text-red fs-5">
                                    {t("react_new_booking_no_available_spaces")}
                                </p>

                                <p className="">
                                    {t("react_new_booking_please_update_selection")}
                                </p>

                            </div>
                        )}

                        {(selectedType === 2 && displaySpacesList.length > 0 && (!timeSelectedInStep1 || isTimeMissing)) && (
                            <div className="custom-timepicker mt-3">

                                <label className="popup-inner-title">
                                    {t("react_select_time")}
                                </label>

                                <div className="slot-container d-grid mb-3">

                                    {timeSlots.map((slot, idx) => {

                                        const [start, end] = slot.split("-");

                                        const isDisabled = isStep2SlotDisabled(slot);

                                        const isSelected =
                                            selectedFrom &&
                                            selectedTo &&
                                            slotOverlapsRange(start, end, selectedFrom, selectedTo);

                                        return (
                                            <div
                                                key={idx}
                                                className={`slot ${isDisabled ? "disabled" : ""} ${isSelected ? "active" : ""}`}
                                                onClick={() => {
                                                    if (!isDisabled) handleConsecutiveSlotClick(slot);
                                                }}
                                            >
                                                {slot}
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        )}

                        <div className="participants-list ctm-checklist">
                            {(!!preBookingQuestion && displaySpacesList.length > 0) && (
                                <div className={`form-check bg-white ${checkedPreBookingQue ? "check-active" : ""}`}>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="preBookingQuestion"
                                        checked={checkedPreBookingQue}
                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                    />
                                    <label
                                        className="form-check-label ms-2"
                                        htmlFor={`preBookingQuestion`}
                                    >
                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                    </label>
                                </div>
                            )}
                        </div>


                    </form>
                </div>
            )}

            {/* STEP 3 */}
            {step === 2 && (
                <div className="step active" data-step="2">
                    <form>
                        <div className="d-flex align-items-start justify-content-between">

                            <div className="icon-with-list">

                                <div className="icon-wrap mb-3">
                                    <img src={Images.Participant} className="img-fluid" />
                                    <h4>{FirstName} {LastName}</h4>
                                </div>

                                <div className="icon-wrap mb-3">
                                    <img src={Images.GreenCalender} className="img-fluid" alt="date" />
                                    <h4>
                                        {displaySelectedDate}
                                    </h4>
                                </div>
                                {(selectedFrom !== "00:00" && selectedTo !== "00:00" && selectedFrom !== "" && selectedTo !== "") && (

                                    <div className="icon-wrap mb-3">
                                        <img src={Images.TimeIcon} className="img-fluid" />
                                        <h4>
                                            {t("from")} <span className="zone_text">{selectedFrom}</span> {t("react_to")} <span className="zone_text">{selectedTo}</span>
                                        </h4>
                                    </div>
                                )}

                                <div className="icon-wrap mb-3 align-items-start">
                                    <img src={Images.ZoneMap} className="img-fluid" />
                                    <h4>{(bookingInfo?.ZoneList || []).find((z) => String(z.Id) === String(selectedZone))?.ZoneName || ""}
                                        <span className="zone_text d-block">{" " + spacesList.find((item) => item.Id === selectedSpace)?.SpotName || ""}</span>

                                    </h4>
                                </div>

                            </div>

                            {/* Show CREDIT */}
                            {zoneCreditValue > 0 && (
                                <div className="date-with-credit d-flex align-items-start justify-content-end pe-3">
                                    <a
                                        href="#"
                                        className="orange-outline-with-icon"
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        {individualDayCost === 0 || individualDayCost === "0" ? (
                                            <>
                                                <img src={Images.GrayStar} alt="star" />
                                                <span>{individualDayCost}</span>
                                            </>
                                        ) : (
                                            <>
                                                <img src={Images.OrangeStar} alt="star" />
                                                <span>
                                                    {(`-${individualDayCost}`)}
                                                </span>
                                            </>
                                        )}
                                    </a>
                                </div>
                            )}
                        </div>
                        <div className="text-center">
                            <img src={Images.BookingCompleted} className="img-fluid"></img>
                        </div>
                    </form>
                </div>
            )}
            {/* Single persistent footer — buttons toggle by step, container never remounts (prevents button repaint) */}
            <div className={`actions d-flex ${step > 0 ? "justify-content-between" : "justify-content-end"} mt-3`}>
                {step > 0 && (
                    <button
                        type="button"
                        className="main-btn outline-gray-btn"
                        onClick={step === 1 ? handleStep2Back : handleStep3Back}
                    >
                        {t("back")}
                    </button>
                )}
                {step === 0 && (
                    <button
                        type="button"
                        className={`main-btn fill-green-btn ${errors.vehicle || !selectedZone || shouldDisableNextButton ? "green-disabled" : ""}`}
                        disabled={!!errors.vehicle || !selectedZone || shouldDisableNextButton}
                        onClick={handleStep1Next}
                    >
                        {t("next")}
                    </button>
                )}
                {step === 1 && (
                    <button
                        type="button"
                        className={`main-btn fill-green-btn ${isStep2NextDisabled ? "green-disabled" : ""}`}
                        disabled={isStep2NextDisabled}
                        onClick={() => setStep(2)}
                    >
                        {t("next")}
                    </button>
                )}
                {step === 2 && (
                    <button
                        type="button"
                        className="main-btn fill-green-btn"
                        onClick={handleConfirmBooking}
                    >
                        {t("confirm")}
                    </button>
                )}
            </div>
            {/* {(notification && !isLoading) && ( */}
            {notification && (
                <NotificationMessage
                    type={notification.type}
                    title={notification.title}
                    message={notification.message}
                    onClose={() => setNotification(null)}
                />
            )}
            {showPostbookingQueModal && (
                <PostbookingQueModal
                    questions={postbookingQueModalData}
                    onClose={() => {
                        setShowPostbookingQueModal(false);
                        history.push("/booking");
                    }}
                    onSubmit={async () => {

                        setShowPostbookingQueModal(false);
                        history.push("/booking");

                    }}
                    postRequestParams={postRequestParams}
                    selectedBookingDate={selectedDate || postRequestParams?.ClaimDate}
                />
            )}
            {showNoVehiclePopup && (
                <NoVehiclePopUp
                    variant="orange"
                    message={t("react_parking_space_booking")}
                    onClose={() => setShowNoVehiclePopup(false)}
                    onConfirm={() => setShowNoVehiclePopup(false)}
                />
            )}
            {renderApiUi(isLoading)}
        </div>
    );
};

export default BookParkingOrDesk;
